import { useRef, useState } from "react"
import _ from "lodash"

//Formik
import { useField } from "formik"

//PrimeReact
import { Editor } from "primereact/editor"

//Styles
import myStyles from "../../../../styles/kiosk/KioskAdminFormWizard.module.css"
import SpecialFieldsDialog from "./SpecialFieldsDialog"

export default function MessageBodyEditor({
  bodyFieldName,
  subjectFieldName,
  height,
  disabled,
  label,
  required,
}) {
  const [field, , helpers] = useField(bodyFieldName)
  const [subjectField, , subjectHelpers] = useField(
    subjectFieldName || bodyFieldName,
  ) //Fallback to bodyFieldName if subjectFieldName isn't provided, to allow for reuse of this component in non-email contexts where there may not be a subject field

  const editorRef = useRef(null)

  const [showSpecialField, setShowSpecialField] = useState(false)

  const renderHeaderEditor = () => {
    return (
      <>
        <span className="ql-formats">
          <button className="ql-bold" aria-label="Bold"></button>
          <button className="ql-italic" aria-label="Italic"></button>
        </span>
        <span className="ql-formats">
          <button className="ql-underline" aria-label="Underline"></button>
          <button className="ql-strike" aria-label="Strike"></button>
          <button className="ql-link" aria-label="Link"></button>
        </span>
        <span className="ql-formats">
          <button
            type="button"
            className="ql-list"
            value="ordered"
            aria-label="Ordered List"
          ></button>
          <button
            type="button"
            className="ql-list"
            value="bullet"
            aria-label="Unordered List"
          ></button>
        </span>
      </>
    )
  }

  return (
    <div className={myStyles.specialFieldEditor}>
      {showSpecialField ? (
        <SpecialFieldsDialog
          onCancel={() => {
            setShowSpecialField(false)
          }}
          fieldName={bodyFieldName}
          selectApplication={subjectFieldName}
          onAddSpecialFields={({
            specialFields,
            applyToSubject,
            applyToBody,
          }) => {
            if (applyToBody) {
              if (editorRef.current && !_.isEmpty(field.value)) {
                editorRef.current.quill.insertText(
                  editorRef.current.quill?.selection?.savedRange?.index ||
                    field.value.length,
                  specialFields,
                )
              } else {
                const newValue = (field.value ?? "") + specialFields
                helpers.setValue(newValue)
              }
            }

            if (applyToSubject) {
              subjectHelpers.setValue(
                (subjectField?.value ?? "") + specialFields,
              )
            }

            setShowSpecialField(false)
          }}
        />
      ) : null}
      <>
        <label>
          {label} {required ? <span style={{ color: "red" }}> * </span> : null}
        </label>
        <Editor
          ref={editorRef}
          id={bodyFieldName}
          value={field.value}
          onTextChange={(e) => {
            helpers.setValue(e.htmlValue)
          }}
          style={{ height: `${height || 50.72}px` }}
          readOnly={disabled}
          headerTemplate={renderHeaderEditor()}
          className={`${myStyles.editor_field} custom_editor`}
        />
      </>
      <div className={myStyles.buttonSpecialField}>
        <div
          onClick={() => {
            setShowSpecialField(true)
          }}
          style={{
            opacity: disabled ? 0.5 : 1,
            pointerEvents: disabled ? "none" : "auto",
          }}
        >
          <span className={`material-icons`}>{"add"}</span>{" "}
          <span>Insert special fields</span>
        </div>
      </div>
    </div>
  )
}
